import React from 'react';
import { AlertCircle } from 'lucide-react';

const ProModal = ({
    showProModal,
    setShowProModal,
    proCode,
    setProCode,
    error,
    setError,
    handleProCodeSubmit
}) => {
    if (!showProModal) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[100] p-4 backdrop-blur-sm">
            <div className="bg-white rounded-xl p-8 max-w-md w-full shadow-2xl transition-all">
                <div className="flex justify-between items-start mb-6">
                    <h3 className="text-2xl font-bold text-gray-800">Sblocca PRO</h3>
                    <button
                        onClick={() => {
                            setShowProModal(false);
                            setProCode('');
                            setError(null);
                        }}
                        className="text-gray-400 hover:text-gray-600 transition-colors"
                    >
                        ✕
                    </button>
                </div>

                <div className="mb-6">
                    <ul className="text-sm text-gray-700 space-y-3 mb-8">
                        <li className="flex items-center gap-2"><span className="text-purple-500">✓</span> Configurazione dominio cliente</li>
                        <li className="flex items-center gap-2"><span className="text-purple-500">✓</span> Analisi diretta con API DataForSEO</li>
                        <li className="flex items-center gap-2"><span className="text-purple-500">✓</span> Insights AI avanzati (Sonnet 3.5)</li>
                        <li className="flex items-center gap-2"><span className="text-purple-500">✓</span> Strategie più approfondite e concrete</li>
                    </ul>

                    <label className="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-2">
                        Codice Attivazione:
                    </label>
                    <input
                        type="text"
                        value={proCode}
                        onChange={(e) => setProCode(e.target.value)}
                        onKeyPress={(e) => e.key === 'Enter' && handleProCodeSubmit()}
                        placeholder="Inserisci il tuo codice PRO"
                        className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent outline-none transition-all"
                    />
                </div>

                {error && (
                    <div className="mb-6 p-4 bg-red-50 border border-red-200 rounded-lg text-red-700 text-sm flex items-center gap-2">
                        <AlertCircle size={16} /> {error}
                    </div>
                )}

                <button
                    onClick={handleProCodeSubmit}
                    className="w-full bg-gradient-to-r from-purple-600 to-indigo-600 hover:from-purple-700 hover:to-indigo-700 text-white font-bold px-4 py-3 rounded-lg transition-all shadow-lg active:scale-95"
                >
                    Attiva Ora
                </button>
            </div>
        </div>
    );
};

export default ProModal;
